export default {
environment: 'staging',
ENV: 'staging',
};
